import "regenerator-runtime/runtime";
import _asyncToGenerator from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import { apolloClient } from '@/apollo/apolloClient';
import { USER_LIST_QUERY } from '@/apollo/queries/user-query';
var state = {
  searching: '',
  searchName: '',
  searchPhoneNumber: '',
  searchSchoolType: '',
  searchSchoolName: '',
  users: []
};
var mutations = {
  UPDATE_USERS: function UPDATE_USERS(state, users) {
    state.users = users.map(function (user) {
      return user;
    });
  },
  setSearching: function setSearching(state, val) {
    state.searching = val;
  },
  setSearchName: function setSearchName(state, val) {
    state.searchName = val;
  },
  setSearchPhoneNumber: function setSearchPhoneNumber(state, val) {
    state.searchPhoneNumber = val;
  },
  setSearchSchoolType: function setSearchSchoolType(state, val) {
    state.searchSchoolType = val;
  },
  setSearchSchoolName: function setSearchSchoolName(state, val) {
    state.searchSchoolName = val;
  },
  clear: function clear(state) {
    state.searching = '';
    state.searchName = '';
    state.searchPhoneNumber = '';
    state.searchSchoolType = '';
    state.searchSchoolName = '';
    state.users = [];
  }
};
var actions = {
  fetchUsers: function () {
    var _fetchUsers = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, _sText, _sName, _sPhoneNumber, _sSchoolType, _sSchoolName, res;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;

              if (state.searching) {
                _sText = '%' + state.searching + '%';
              } else {
                _sText = '%';
              } // console.log('_sText:' + _sText)


              if (state.searchName) {
                _sName = '%' + state.searchName + '%';
              } else {
                _sName = '%';
              } // console.log('_sName:' + _sName)


              if (state.searchPhoneNumber) {
                _sPhoneNumber = '%' + state.searchPhoneNumber + '%';
              } else {
                _sPhoneNumber = null; // '%'
              } // console.log('_sPhoneNumber:' + _sPhoneNumber)


              if (state.searchSchoolType) {
                _sSchoolType = '%' + state.searchSchoolType + '%';
              } else {
                _sSchoolType = null; // '%'
              } // console.log('_sSchoolType:' + _sSchoolType)


              if (state.searchSchoolName) {
                _sSchoolName = '%' + state.searchSchoolName + '%';
              } else {
                _sSchoolName = null; // '%'
              } // console.log('_sSchoolName:' + _sSchoolName)


              _context.next = 8;
              return apolloClient.query({
                query: USER_LIST_QUERY,
                variables: {
                  searchText: _sText,
                  searchName: _sName,
                  searchPhoneNumber: _sPhoneNumber,
                  searchSchoolName: _sSchoolName,
                  searchSchoolType: _sSchoolType
                },
                fetchPolicy: 'no-cache'
              });

            case 8:
              res = _context.sent;
              // console.log(JSON.stringify(res.data.user))
              commit('UPDATE_USERS', res.data.user);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function fetchUsers(_x) {
      return _fetchUsers.apply(this, arguments);
    }

    return fetchUsers;
  }(),
  setSearching: function () {
    var _setSearching = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref2, searching) {
      var commit;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              // console.log('setSearching:' + searching)
              commit('setSearching', searching);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function setSearching(_x2, _x3) {
      return _setSearching.apply(this, arguments);
    }

    return setSearching;
  }(),
  setSearchName: function () {
    var _setSearchName = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref3, searchName) {
      var commit;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              // console.log('searchName:' + searchName)
              commit('setSearchName', searchName);

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function setSearchName(_x4, _x5) {
      return _setSearchName.apply(this, arguments);
    }

    return setSearchName;
  }(),
  setSearchPhoneNumber: function () {
    var _setSearchPhoneNumber = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(_ref4, searchPhoneNumber) {
      var commit;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;
              // console.log('searchPhoneNumber:' + searchPhoneNumber)
              commit('setSearchPhoneNumber', searchPhoneNumber);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function setSearchPhoneNumber(_x6, _x7) {
      return _setSearchPhoneNumber.apply(this, arguments);
    }

    return setSearchPhoneNumber;
  }(),
  setSearchSchoolType: function () {
    var _setSearchSchoolType = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(_ref5, searchSchoolType) {
      var commit;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref5.commit;
              // console.log('searchSchoolType:' + searchSchoolType)
              commit('setSearchSchoolType', searchSchoolType);

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function setSearchSchoolType(_x8, _x9) {
      return _setSearchSchoolType.apply(this, arguments);
    }

    return setSearchSchoolType;
  }(),
  setSearchSchoolName: function () {
    var _setSearchSchoolName = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(_ref6, searchSchoolName) {
      var commit;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref6.commit;
              // console.log('searchSchoolName:' + searchSchoolName)
              commit('setSearchSchoolName', searchSchoolName);

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function setSearchSchoolName(_x10, _x11) {
      return _setSearchSchoolName.apply(this, arguments);
    }

    return setSearchSchoolName;
  }(),
  clear: function () {
    var _clear = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7(_ref7) {
      var commit;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref7.commit;
              commit('clear');

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function clear(_x12) {
      return _clear.apply(this, arguments);
    }

    return clear;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};